import { render, staticRenderFns } from "./EDSCriteriaAdd.vue?vue&type=template&id=4af50b55&"
import script from "./EDSCriteriaAdd.vue?vue&type=script&lang=js&"
export * from "./EDSCriteriaAdd.vue?vue&type=script&lang=js&"
import style0 from "./EDSCriteriaAdd.vue?vue&type=style&index=0&id=4af50b55&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports